import { StarListMode } from '@apeiron/star'
import FavoriteSecNavBar from '@src/components/navigationBar/secondary/FavoriteSecNavBar'
import StarListWithFilter from '@src/components/stars/list/StarListWithFilter'
import { GAAssetType } from '@src/constants/googleAnalytics'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import withListTracking from '@src/hoc/withListTracking'
import type { NextPage } from 'next'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const WithTrackingStarList = withListTracking(GAAssetType.Star)(
  StarListWithFilter
)

const StarFavoritePage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  const { t } = useTranslation()

  useEffect(() => {
    setupBar(<FavoriteSecNavBar index={2} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <WithTrackingStarList
      emptyMessage={t('favorite.star_empty')}
      mode={StarListMode.FAVORITE}
      title={t('favorite.title')}
    />
  )
}

type Props = {}

export default StarFavoritePage
